import React from "react";
import "../css/tabs.css"; // Custom CSS for tabs
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHotel,
  faCalendar,
  faUtensils,
  faLandmark,
  faShoppingBag,
} from "@fortawesome/free-solid-svg-icons";

const Tabs = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { name: "Accommodation", icon: faHotel },
    { name: "Events", icon: faCalendar },
    { name: "Restaurants", icon: faUtensils },
    { name: "Attractions", icon: faLandmark },
    { name: "Shopping Malls", icon: faShoppingBag },
    { name: "Buses", icon: faShoppingBag },
  ];

  return (
    <div className="tabs-container">
      {tabs.map((tab) => (
        <button
          key={tab.name}
          className={`tab-button ${activeTab === tab.name ? "active" : ""}`}
          onClick={() => setActiveTab(tab.name)}
        >
          <div className="tab-inner">
            <FontAwesomeIcon icon={tab.icon} className="tab-icon" />
            <span className="tab-text">{tab.name}</span>
          </div>
        </button>
      ))}
    </div>
  );
};

export default Tabs;
